import SwapCancellationPanel from '@/views/WorkScheduleSwap/SwapCancellationPanel'

let routes = {
    path: '/WorkSchedulesSwapCancellation',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/WorkSchedulesSwapCancellation',
            name: 'Solicitação de Cancelamento de Troca',
            component: SwapCancellationPanel
        },
    ]
};

export default routes
